import _ from 'lodash';
import React from 'react';
import { Flex, Separator } from 'components/base/layout-components';
import { getRangeByValue } from '../services/projects.services';
import { DELIVERY_STATES_API_KEYS } from '../projects.consts';
import AccuracyBox from './AccuracyBox';
import { getColor } from 'common/constants/_colors';
import AccuracyBoxTooltipContent from './AccuracyBoxTooltipContent';

const AccuracyColumn = ({ lineChartData, totals }) => {
  return (
    <Flex width='100%' data-testid='accuracy-column'>
      {lineChartData.map((item, index) => {
        const {
          key,
          ranges,
          totalValue,
          totalSuffix,
          color,
          chartTitle,
          title,
          subtitle
        } = item;

        const rangeObj = getRangeByValue(totalValue, ranges);
        const {
          title: rangeTitle,
          text = _.noop,
          statusIconName,
          contentColor,
          description = ''
        } = rangeObj;

        const {
          [DELIVERY_STATES_API_KEYS.PLANNED]: planned,
          [DELIVERY_STATES_API_KEYS.COMPLETED]: completed,
          [DELIVERY_STATES_API_KEYS.ADDED]: added
        } = totals;

        const tooltipContent = AccuracyBoxTooltipContent(
          title,
          subtitle,
          text,
          planned,
          completed,
          added,
          color,
          statusIconName
        );

        return (
          <Flex key={key}>
            <Flex justify='center' data-testid='accuracy-box'>
              <AccuracyBox
                statusIconName={statusIconName}
                targetIconColor={color}
                percent={`${totalValue}${totalSuffix}`}
                content={rangeTitle}
                contentColor={contentColor}
                AccuracyType={chartTitle}
                tooltipContent={tooltipContent}
                description={description}
              />
            </Flex>
            {index === 0 && (
              <Separator
                color={getColor('catskillWhite')}
                height='100%'
                margin='0 2.8rem 0 0'
                data-testid='separator'
              />
            )}
          </Flex>
        );
      })}
    </Flex>
  );
};

export default AccuracyColumn;
